import * as type from '../actions/types';

const initialState = {
  data: {},
  fetching: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_FORECAST_V3_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
        success: false,
      };
    case type.FETCH_FORECAST_V3_SUCCESS:
      return {
        ...state,
        data: action.payload,
        fetching: false,
        error: false,
        errorMessage: '',
        success: true,
      };
    case type.FETCH_FORECAST_V3_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };
    default:
      return state;
  }
};
